import * as React from "react";
import { RecordInfo } from "models/ApiModels";
import { AppImages } from "assets/appResources";
import { Avatar } from "@mui/material";


interface IProps {
    record: RecordInfo
}

export const RecordUserThumbnail: React.FC<IProps> = (props) => {
    return (
        <Avatar
            src={
                props.record.creator?.isSystemUser && props.record?.creator?.id == props.record.revisor?.id
                    ? AppImages.SystemUserThumbnail
                    : props.record.creator?.id != props.record.revisor?.id
                        ? props.record.revisor?.thumbnailUrl || AppImages.DefaultUserThumbnail
                        : props.record.creator?.thumbnailUrl || AppImages.DefaultUserThumbnail
            }
        />
    );
};
